import { render, staticRenderFns } from "./AdminOverlayWindow.vue?vue&type=template&id=1108a86f&"
import script from "./AdminOverlayWindow.vue?vue&type=script&lang=ts&"
export * from "./AdminOverlayWindow.vue?vue&type=script&lang=ts&"
import style0 from "./AdminOverlayWindow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports